// Check if the current URL matches the old collection URL
if (window.location.href === "https://gardeningwithcreekside.com/collections/jenny-s-auger-collection") {
    // Redirect to the new collection URL
    window.location.href = "https://gardeningwithcreekside.com/collections/jennys-auger-collection";
}


jQuery(document).ready(function($) {
    $('body.product.slug-products.aquapots-lite-inserts form.add-to-cart').after('<div class="discount_notice"><p><strong>Disclaimer:</strong> No discounts can be applied to this product.</p></div>');
    $('body.power-planter-augers form.add-to-cart').after('<div class="discount_notice"><p><strong>Disclaimer:</strong> No discounts can be applied to this product.</p></div>');
  });
/*
jQuery(document).ready(function($){
    // Check if the current URL contains '/collections/' and doesn't contain '?rb_stock_status=In%20Stock'
    if(window.location.href.indexOf("/collections/") > -1 && window.location.href.indexOf("?rb_stock_status=In%20Stock") === -1) {
        // If it does, redirect to the current URL with '?rb_stock_status=In%20Stock' appended
        window.location.href += "?rb_stock_status=In%20Stock";
    }
});
*/

if (window.location.href === "https://gardeningwithcreekside.com/collections") {
  window.location.href = "https://gardeningwithcreekside.com/";
}

if (window.location.href === "https://gardeningwithcreekside.com/collections/?_kx=OgoENpR5xuNvVNLt9GTCU2w2EKDHsX7m24-GUIZwj5Y.WmiiCG?rb_stock_status=In%20Stock") {
  window.location.href = "https://gardeningwithcreekside.com/";
}

if (window.location.href === "https://gardeningwithcreekside.com/collections/?rb_stock_status=In%20Stock") {
  window.location.href = "https://gardeningwithcreekside.com/";
}


document.addEventListener("DOMContentLoaded", function() {
    // Check if the current URL contains '/products/'
    if (window.location.href.indexOf('/products/') > -1) {
        // Check if the URL also contains '?bis=true'
        if (window.location.href.indexOf('?notify-me=1') > -1) {
            // Function to wait for .klaviyo-bis-trigger to appear and then click it
            function waitForElementAndClick(selector) {
                const element = document.querySelector(selector);
                if (element) {
                  setTimeout(function() {
                    document.querySelector('.klaviyo-bis-trigger').click();
                     }, 700);
                } else {
                    // If element is not found, try again after 500ms
                    setTimeout(function() {
                        waitForElementAndClick(selector);
                    }, 500);
                }
            }

            // Call the function to wait for .klaviyo-bis-trigger and click it
            waitForElementAndClick('.klaviyo-bis-trigger');
        }
    }
});




document.addEventListener('DOMContentLoaded', function() {
  fetch('/browsing_context_suggestions.json')
    .then(response => response.json())
    .then(data => {
      const countryCode = data?.detected_values?.country?.handle; 
      const currentURL = window.location.href; 

      if (countryCode !== 'US' && countryCode !== 'MK' && currentURL.includes('gift-card')) {
        // User is from Canada and the URL contains 'gift-card'
        const targetElement = document.querySelector('.add-to-cart--quantity-and-add.mt-8.flex');
        if (targetElement) {
          const messageElement = document.createElement('p');
          messageElement.textContent = 'Only for US Customers';
          targetElement.replaceWith(messageElement); 
        }
      }
    })
    .catch(error => {
      console.error('Error:', error);
      
    });
});
